export const  fonts = {
  heading: `'Humanst', sans-serif`,
  body: `'Satoshi', sans-serif`
}